const validate = (values) => {
    const errors = {};
    if (!values.programId) {
        errors.programId = 'Please select program';
    }
    if (!values.targetId) {
        errors.targetId = 'Please select target';
    }
    return errors;
};
export default validate;




// WEBPACK FOOTER //
// ./src/modules/patients/components/DataAnalytics/validate.js